// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-05-30",
  "topic": "德州扑克牌型大小 / 德州扑克规则图解 / 德州扑克术语大全",
  "metaKeywords": "德州扑克牌型大小, 德州扑克规则图解, 德州扑克术语大全, 德州扑克盲注规则, 德州扑克翻牌圈玩法, hhpoker怎么玩, hhpoker新手入门, 德州扑克起手牌策略, 德州扑克位置打法, 德州扑克常见错误",
  "focusKeywords": [
    {
      "keyword": "德州扑克牌型大小",
      "path": "/guide",
      "anchorText": "德州扑克牌型大小教程"
    },
    {
      "keyword": "德州扑克规则图解",
      "path": "/guide",
      "anchorText": "德州扑克规则图解"
    },
    {
      "keyword": "德州扑克术语大全",
      "path": "/guide",
      "anchorText": "德州扑克术语大全入口"
    },
    {
      "keyword": "德州扑克盲注规则",
      "path": "/guide",
      "anchorText": "德州扑克盲注规则攻略"
    },
    {
      "keyword": "德州扑克翻牌圈玩法",
      "path": "/guide",
      "anchorText": "德州扑克翻牌圈玩法"
    },
    {
      "keyword": "hhpoker怎么玩",
      "path": "/guide",
      "anchorText": "hhpoker怎么玩入口"
    },
    {
      "keyword": "hhpoker新手入门",
      "path": "/guide",
      "anchorText": "hhpoker新手入门攻略"
    },
    {
      "keyword": "德州扑克起手牌策略",
      "path": "/guide",
      "anchorText": "德州扑克起手牌策略"
    },
    {
      "keyword": "德州扑克位置打法",
      "path": "/guide",
      "anchorText": "德州扑克位置打法入口"
    },
    {
      "keyword": "德州扑克常见错误",
      "path": "/guide",
      "anchorText": "德州扑克常见错误教程"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克牌型大小怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议通过本站专题页查看最新图文步骤，再结合自身设备和版本操作，遇到问题可通过客服渠道提交截图快速处理。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克规则图解怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克术语大全怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议通过本站专题页查看最新图文步骤，再结合自身设备和版本操作，遇到问题可通过客服渠道提交截图快速处理。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克盲注规则怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    }
  ]
};

export default dailySeoContent;
